module.exports = __webpack_public_path__ + "img/TUR-A-2-II.b59dab67.png";